import { useEffect, useState } from 'react';
import { Eye, X } from 'lucide-react';
import { clearRoleOverride, getRoleOverride, subscribeRoleOverride } from '../../utils/roleOverride';
import { getRoleLabel } from '../../constants/roles';

function formatRemaining(expiresAt) {
  const ms = expiresAt - Date.now();
  if (ms <= 0) return 'expired';
  const minutes = Math.ceil(ms / 60000);
  return `${minutes}m left`;
}

export default function RoleOverrideBanner() {
  const [override, setOverride] = useState(() => getRoleOverride());

  useEffect(() => subscribeRoleOverride(setOverride), []);

  // Tick the countdown once a minute so users see the timer drain.
  useEffect(() => {
    if (!override) return undefined;
    const id = setInterval(() => setOverride(getRoleOverride()), 60_000);
    return () => clearInterval(id);
  }, [override]);

  if (!override) return null;

  const labels = override.roles.map(getRoleLabel).join(', ');

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-crm-warning-bg border-b border-crm-warning text-crm-warning-text text-xs font-medium py-1.5 px-4 flex items-center justify-center gap-3"
    >
      <Eye className="w-3.5 h-3.5 flex-shrink-0" />
      <span>
        Viewing as <strong>{labels}</strong> · {formatRemaining(override.expiresAt)}
      </span>
      <button
        type="button"
        onClick={clearRoleOverride}
        className="inline-flex items-center gap-1 rounded border border-crm-warning px-2 py-0.5 hover:bg-white/40 transition"
      >
        <X className="w-3 h-3" />
        Exit
      </button>
    </div>
  );
}
